/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import apiService from '@services/apiService';

const ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER';
const ADD_TEAM_MEMBER_FAIL = 'ADD_TEAM_MEMBER_FAIL';
const ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS';

const REMOVE_TEAM_MEMBER = 'REMOVE_TEAM_MEMBER';
const REMOVE_TEAM_MEMBER_FAIL = 'REMOVE_TEAM_MEMBER_FAIL';
const REMOVE_TEAM_MEMBER_SUCCESS = 'REMOVE_TEAM_MEMBER_SUCCESS';

const SEARCH_TEAM_MEMBER = 'SEARCH_TEAM_MEMBER';
const SEARCH_TEAM_MEMBER_FAIL = 'SEARCH_TEAM_MEMBER_FAIL';
const SEARCH_TEAM_MEMBER_SUCCESS = 'SEARCH_TEAM_MEMBER_SUCCESS';

const initialState = {
  error: false,
  loading: false,
  canBeImpersonatedBy: [],
  canImpersonate: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEAM_MEMBER:
    case REMOVE_TEAM_MEMBER:
    case SEARCH_TEAM_MEMBER:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case ADD_TEAM_MEMBER_SUCCESS:
    case REMOVE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };
    case SEARCH_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        canBeImpersonatedBy: action.payload.canBeImpersonatedBy,
        canImpersonate: action.payload.canImpersonate,
        error: false,
        loading: false,
      };
    case ADD_TEAM_MEMBER_FAIL:
    case REMOVE_TEAM_MEMBER_FAIL:
    case SEARCH_TEAM_MEMBER_FAIL:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};

const addTeamMember = member => async dispatch => {
  dispatch({ type: ADD_TEAM_MEMBER });
  try {
    await apiService.TeamsManagement.AddMember(member);
    dispatch({ type: ADD_TEAM_MEMBER_SUCCESS });
    return true;
  } catch (err) {
    console.error('Error: TeamsManagement addTeamMember', err);
    dispatch({ type: ADD_TEAM_MEMBER_FAIL });
    return false;
  }
};

const removeTeamMember = member => async dispatch => {
  dispatch({ type: REMOVE_TEAM_MEMBER });
  try {
    await apiService.TeamsManagement.RemoveMember(member);
    dispatch({ type: REMOVE_TEAM_MEMBER_SUCCESS });
    return true;
  } catch (err) {
    console.error('Error: TeamsManagement removeTeamMember', err);
    dispatch({ type: REMOVE_TEAM_MEMBER_FAIL });
    return false;
  }
};

const searchTeamMember = member => async dispatch => {
  dispatch({ type: SEARCH_TEAM_MEMBER });
  try {
    const impersonationDetails = await apiService.TeamsManagement.SearchMember(member);
    dispatch({
      type: SEARCH_TEAM_MEMBER_SUCCESS,
      payload: { ...impersonationDetails },
    });
  } catch (err) {
    console.error('Error: TeamsManagement searchTeamMember', err);
    dispatch({ type: SEARCH_TEAM_MEMBER_FAIL });
  }
};

export {
  addTeamMember,
  removeTeamMember,
  searchTeamMember,
};
